var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "price_tag",
    "data-name": "price tag"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.23,11.44l-3.9-3.9a1,1,0,0,0-1.41,0,1,1,0,0,0,0,1.42l3.89,3.9a.65.65,0,0,1,.19.45V21a1,1,0,0,0,2,0V13.31A2.65,2.65,0,0,0,23.23,11.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23,24a1,1,0,0,0-1,1v2.35a.65.65,0,0,1-.65.65H10.65a.65.65,0,0,1-.65-.65v-14a.65.65,0,0,1,.19-.45L14,9a1,1,0,0,0,0-1.42,1,1,0,0,0-1.41,0L8.77,11.45A2.61,2.61,0,0,0,8,13.31v14A2.65,2.65,0,0,0,10.65,30h10.7A2.65,2.65,0,0,0,24,27.35V25A1,1,0,0,0,23,24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.36,17.23l-6,5a1,1,0,0,0-.13,1.41A1,1,0,0,0,13,24a1,1,0,0,0,.64-.23l6-5a1,1,0,1,0-1.28-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14,18a1,1,0,0,0-1-1h0a1,1,0,1,0,1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19,22a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14,11a1,1,0,0,0,1,1h2a1,1,0,0,0,0-2V3a1,1,0,0,0-2,0v7A1,1,0,0,0,14,11Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSale);
export default __webpack_public_path__ + "static/media/sale.bdd8800373f11094c426f33dd722622c.svg";
export { ForwardRef as ReactComponent };